@import '../../../theme/colors';

$breakpoint-xs: 640px;
$breakpoint-sm: 1020px;
$breakpoint-md: 1200px;

.row {
  padding: 8px 0;
  border-bottom: 1px solid $lightGrey;
  width: 100%;
  min-width: 640px;
}

.rowInner {
  // bottom padding to account for absolute positioned add buttons
  padding: 12px 0;
  background-color: #f8f8f8;
}

.controls {
  display: flex;
  align-items: flex-start;
}

.attributeOperator {
  padding: 16px 0;
}

// Attribute operator text area, when not select menu
.attributeOperatorText {
  width: 96px;
  min-width: 96px;
  height: 40px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  .baseAttributeText,
  .groupOperatorText {
    margin: 0;
    font-family: var(--font-family__body);
    font-size: 0.875rem;
    font-weight: 300;
  }
  .baseAttributeText {
    color: $neutral-600;
  }
  .groupOperatorText {
    color: $neutral-700;
    padding-left: 14px;
  }
}

// Attribute editor (attribute, filterGroup, delete)
.attributeGroup {
  flex: 1;
  min-width: 0;
  &.hasGroupBracket {
    padding: 10px 0;
    margin-left: 10px;
    border-left: 3px solid $neutral-300;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 3px;
      background-color: $neutral-300;
      left: -1px;
      top: 0;
    }
    &::after {
      content: '';
      position: absolute;
      width: 10px;
      height: 3px;
      background-color: $neutral-300;
      left: -1px;
      bottom: 0;
    }
  }
}
.attribute {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
}
.attributeInner {
  flex: 1;
  min-width: 0;
  position: relative;
}
// select inputs
.inputGroup {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  @media (max-width: $breakpoint-sm) {
    flex-direction: column;
    align-items: stretch;
  }
}
// filter inputs (operator, filter)
.filterGroup {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  @media (max-width: $breakpoint-sm) {
    margin-top: 8px;
  }
}

.addControls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  > div:first-child::after {
    content: '';
    width: 2px;
    height: 20px;
    background-color: $lightGrey;
    position: relative;
    right: -8px;
  }
}

.customerCountRow {
  display: flex;
  justify-content: flex-end;
  padding-top: 32px;
}
.customerCountBox {
  margin-right: 12px;
  margin-top: 12px;
}
.customerCount {
  margin: 0;
  padding: 8px;
  font-family: var(--font-family__body);
  font-size: 14px;
  font-weight: 600;
  &.customersFetching {
    opacity: 0.5;
  }
}
